module.exports = __webpack_public_path__ + "img/Kimberley-Clark-1-A.a7e79aa3.jpg";